import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { SidebarComponent } from '../../../../shared/components/sidebar/sidebar.component';
import { AuthService } from '../../../../shared/services/auth.service';
import { ProfileService } from '../../../../shared/services/profile.service';
import { ScrollDisableService } from '../../../../shared/services/scroll-disable.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  imports: [RouterOutlet, SidebarComponent, HeaderComponent],
})
export class DashboardComponent implements OnInit {
  sideBarClass: string = '';
  constructor(
    private authService: AuthService,
    private profileService: ProfileService,
    private readonly scrollDisableService: ScrollDisableService
  ) {}
  ngOnInit(): void {
    this.init();
  }
  init() {
    this.profileService.profileDetails.subscribe((value) => {
      if (!value) {
        this.getProfile();
      }
    });
  }
  getProfile() {
    this.profileService.fetchProfile().subscribe((data) => {
      this.profileService.setProfileDetails(data.profile);
    });
  }

  refreshToken() {}

  showSideBar() {
    if (this.sideBarClass) {
      this.sideBarClass = '';
      this.scrollDisableService.addScroll('disable-scroll-mobile');
    } else {
      this.sideBarClass = 'active';
      this.scrollDisableService.stopScroll('disable-scroll-mobile');
    }
  }
  closeSideBar() {
    this.sideBarClass = '';
    this.scrollDisableService.addScroll('disable-scroll-mobile');
  }
}
